import { render, staticRenderFns } from "./icon-change-password.vue?vue&type=template&id=56503540"
import script from "./icon-change-password.vue?vue&type=script&lang=js"
export * from "./icon-change-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports